/* Presentation only: native Shrine owns gallery filtering, variants and purchase state. */
(() => {
  function initAccents() {
    const main = document.querySelector('#MainContent[data-racer-product="9728791216387"]');
    if (!main || main.dataset.racerAccentsReady) return;
    const variantIds = new Set(JSON.parse(main.querySelector('[data-racer-variant-data]')?.textContent || '[]').map(variant => String(variant.id)));
    main.dataset.racerAccentsReady = 'true';
    const section = main.querySelector('.ns-purchase[data-ns-section]')?.dataset.nsSection;
    const apply = (id) => {
      id = String(id ?? '');
      if (variantIds.has(id)) main.dataset.racerVariant = id;
    };
    // Liquid selected_or_first_available_variant already respects initial ?variant= URLs.
    apply(main.querySelector('product-form.main-product-form form [name="id"]')?.value || main.dataset.racerVariant);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event?.data?.sectionId) === section) apply(event.data.variant?.id);
      });
    }
  }

  function initCarousel(carousel) {
    if (carousel.dataset.ready) return;
    const viewport = carousel.querySelector('[data-racer-carousel-viewport]');
    const slides = [...carousel.querySelectorAll('[data-racer-carousel-slide]')];
    const dots = [...carousel.querySelectorAll('[data-racer-carousel-dot]')];
    const status = carousel.querySelector('[data-racer-carousel-status]');
    if (!viewport || slides.length < 2 || dots.length !== slides.length) return;
    carousel.dataset.ready = 'true';
    let active = 0;
    let frame = 0;
    const offset = (index) => slides[index].offsetLeft - slides[0].offsetLeft;
    function sync(index, announce = true) {
      const changed = active !== index;
      active = index;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', String(i !== active)));
      dots.forEach((dot, i) => {
        if (i === active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (changed && announce) status.textContent = `${active + 1} of ${slides.length}: ${slides[active].dataset.design}`;
    }
    function go(index) {
      index = (index + slides.length) % slides.length;
      viewport.scrollTo({left: offset(index), behavior: 'auto'});
      sync(index);
    }
    carousel.querySelector('[data-racer-carousel-prev]').addEventListener('click', () => go(active - 1));
    carousel.querySelector('[data-racer-carousel-next]').addEventListener('click', () => go(active + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => go(i)));
    viewport.addEventListener('keydown', (event) => {
      if (event.target !== viewport) return;
      const destinations = {ArrowLeft: active - 1, ArrowRight: active + 1, Home: 0, End: slides.length - 1};
      if (!(event.key in destinations)) return;
      event.preventDefault();
      go(destinations[event.key]);
    });
    // Native overflow/snap provides touch swiping without competing pointer handlers.
    viewport.addEventListener('scroll', () => {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        let nearest = 0;
        slides.forEach((slide, i) => {
          if (Math.abs(offset(i) - viewport.scrollLeft) < Math.abs(offset(nearest) - viewport.scrollLeft)) nearest = i;
        });
        sync(nearest);
      });
    }, {passive: true});
    sync(0, false);
    carousel.querySelector('[data-racer-carousel-controls]').hidden = false;
  }

  function init() {
    initAccents();
    document.querySelectorAll('[data-racer-design-carousel]').forEach(initCarousel);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once: true});
  else init();
  document.addEventListener('shopify:section:load', init);
})();
